import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

const SECTIONS = [
  { id: 'conversations', label: 'Conversaciones', icon: '💬' },
];

export default function AgentSidebar({ active, onSelect }) {
  const isMobile = useIsMobile();
  return (
    <div style={{
      width: isMobile ? '48px' : '64px', display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: isMobile ? '0.5rem 0' : '1rem 0', gap: '0.5rem', flexShrink: 0,
      backgroundColor: theme.colors.surface,
      borderRight: `1px solid ${theme.colors.border}`,
    }}>
      {SECTIONS.map((s) => (
        <button
          key={s.id}
          title={s.label}
          onClick={() => onSelect(s.id)}
          style={{
            width: isMobile ? '38px' : '44px', height: isMobile ? '38px' : '44px', borderRadius: '10px', border: 'none',
            cursor: 'pointer', fontSize: isMobile ? '1.1rem' : '1.3rem',
            background: active === s.id ? theme.colors.glowStrong : 'transparent',
            outline: active === s.id ? `2px solid ${theme.colors.border}` : 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {s.icon}
        </button>
      ))}
    </div>
  );
}
